import noop from 'lodash/noop';
import flatMap from 'lodash/flatMap';
import uniqBy from 'lodash/uniqBy';

import { readable, derived } from 'svelte/store'
import { hiringApi } from 'src/api'

export const Jobs = readable([], (set) => {
  hiringApi.get('/public/job/', { params: { published: true } }).then(resp => set(resp.data));
  return noop
})

export const LocationOptions = derived(Jobs, jobs => {
  const locations = flatMap(jobs, job => job.locations.map(loc => ({ value: loc.id, label: loc.title })));
  return uniqBy(locations, 'value');
})
